import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { getLeads, getRepresentatives, uploadLeadsExcel } from "./leadsThunks";
import API_BASE_URL, { SCHOOL_QUIZ_API_BASE_URL } from "../../config";
import axios from "axios";
import { getAgeGroups } from "../../../School-Quiz-Mgt-admin/redux/thunk";
import { getSubjectsNew, getClassesNew, quizTypesNew } from "./config";
//get themes
export const fetchThemes = createAsyncThunk(
  "themes/fetchThemes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${SCHOOL_QUIZ_API_BASE_URL}/themes`);
      return response.data || [];
    } catch (error) {
      console.error("fetchThemes error:", error);
      return rejectWithValue("Failed to fetch themes");
    }
  }
);

export const fetchSubjects = createAsyncThunk(
  "themes/fetchSubjects",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(getSubjectsNew);
      console.log("📦 API response:", response.data);

      // ✅ Extract subjects array properly
      const subjects = Array.isArray(response.data?.data)
        ? response.data.data
        : Array.isArray(response.data)
          ? response.data
          : [];

      // ✅ Filter only active ones
      const activeSubjects = subjects.filter((s) => s.status === 1);
      console.log("🎯 Active subjects:", activeSubjects);

      // ✅ Return with `data` key to match your component usage
      return { data: activeSubjects };
    } catch (error) {
      console.error("❌ fetchSubjects error:", error);
      return rejectWithValue("Failed to fetch subjects");
    }
  }
);


export const fetchClasses = createAsyncThunk(
  "themes/fetchClasses",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${getClassesNew}`);
      return response.data || [];
    } catch (error) {
      console.error("fetchClasses error:", error);
      return rejectWithValue("Failed to fetch subjects");
    }
  }
);

export const fetchGroups = createAsyncThunk(
  "groups/fetchGroups",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${SCHOOL_QUIZ_API_BASE_URL}/groups`);
      return response.data || [];
    } catch (error) {
      console.error("fetchGroups error:", error);
      return rejectWithValue("Failed to fetch groups");
    }
  }
);

export const uploadQuizExcel = createAsyncThunk(
  "schoolQuiz/uploadQuizExcel",
  async (payload, { rejectWithValue }) => {
    try {
      const {
        file,
        created_by, // user_id
        classId,
        subjectId,
        difficultyLevel,
        theme_id,
        group_id,
        quizType,
        age_group_id,
      } = payload;

      const formData = new FormData();
      formData.append("file", file);
      console.log(quizType);
      // Append other fields
      if (created_by !== undefined) formData.append("user_id", created_by);
      if (classId !== undefined) formData.append("class_id", classId);
      if (subjectId !== undefined) formData.append("subject_id", subjectId);
      if (difficultyLevel !== undefined)
        formData.append("level", difficultyLevel);

      if (quizType != null) {
        formData.append("quizType", quizType);
      }
      // ✅ Handle theme_id robustly
      if (theme_id !== undefined) {
        let themeArray = [];

        if (Array.isArray(theme_id)) {
          // already an array like [6, 10]
          themeArray = theme_id.map(Number);
        } else if (typeof theme_id === "string") {
          // could be "6" or "6,10"
          themeArray = theme_id
            .split(",")
            .map((v) => v.trim())
            .map(Number)
            .filter((v) => !isNaN(v));
        } else {
          // single numeric value
          themeArray = [Number(theme_id)];
        }

        // ✅ append JSON stringified array
        formData.append("theme_id", JSON.stringify(themeArray));
      }

      if (group_id !== undefined) formData.append("group_id", group_id);
      if (age_group_id !== undefined)
        formData.append("age_group_id", age_group_id);

      // ✅ URLs
      // const SCHOOL_QUIZ_API_BASE_URL =
      //   "http://localhost:5007/api/school/quiz/admin";
      const live_url = `${SCHOOL_QUIZ_API_BASE_URL}/upload-quiz-questions-excel`;
      const theme_url = `${SCHOOL_QUIZ_API_BASE_URL}/upload-themequiz-questions-excel`;

      // Debug log
      for (let [key, value] of formData.entries()) {
        console.log("pairs", key, value);
      }

      // ✅ Pick endpoint
      // const endpoint = quizType === "thematic" ? theme_url : live_url;
      const endpoint = quizType === 3 || quizType === 4 ? theme_url : live_url;

      // ✅ Send request
      const res = await axios.post(endpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return res.data;
    } catch (err) {
      console.error("Upload failed:", err);
      return rejectWithValue(err?.response?.data || "Upload error");
    }
  }
);

export const viewErrorLogs = createAsyncThunk(
  "schoolCollegeQuiz/viewErrorLogs",
  async ({ requestBody }, { rejectWithValue }) => {
    try {
      const body = requestBody || {};
      const response = await axios.post(
        `${API_BASE_URL}/quiz/admin/school-quiz-questions-upload-errors`,
        body
      );

      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue(
          "No errors in questions found in the uploaded file."
        );
      }
    } catch (error) {
      console.error("Excel Upload Error:", error);
      return rejectWithValue(error.response?.data?.message || "Upload failed.");
    }
  }
);
// replace your existing addManualQuestion thunk with this

//old code
// export const addManualQuestion = createAsyncThunk(
//   "schoolQuiz/addManualQuestion",
//   async (payload = {}, { rejectWithValue }) => {
//     try {
//       // destructure everything we might receive
//       const {
//         created_by,
//         question,
//         correct_option,
//         option_A,
//         option_B,
//         option_C,
//         option_D,
//         level,
//         // optional routing fields
//         class_id,
//         subject_id,
//         theme_id,
//         group_id,
//         quiz_type, // optional explicit flag: "thematic" | "live" | "practice"
//       } = payload;
//       console.log(theme_id);
//       // minimal validation
//       if (!question) return rejectWithValue("Question text is required.");
//       if (!correct_option)
//         return rejectWithValue("Correct option is required.");
//       if (!option_A || !option_B || !option_C || !option_D)
//         return rejectWithValue("All options (A-D) are required.");
//       if (!level) return rejectWithValue("Difficulty level is required.");
//       if (!created_by)
//         return rejectWithValue("created_by (user id) is required.");

//       // base body
//       const body = {
//         created_by,
//         question,
//         correct_option,
//         option_A,
//         option_B,
//         option_C,
//         option_D,
//         level,
//       };

//       // choose endpoint and attach appropriate extra fields
//       const isThematicExplicit = quiz_type === "thematic";
//       const hasThematicFields = theme_id != null || group_id != null;
//       const hasLiveFields = class_id != null || subject_id != null;

//       let url;
//       if (
//         isThematicExplicit ||
//         (!isThematicExplicit && hasThematicFields && !hasLiveFields)
//       ) {
//         // Thematic path
//         const SCHOOL_QUIZ_API_BASE_URLl =
//           "http://localhost:5007/api/school/quiz/admin";
//         url = `${SCHOOL_QUIZ_API_BASE_URLl}/add-theme-question`;
//         // url = `${SCHOOL_QUIZ_API_BASE_URL}/add-theme-question`;
//         if (theme_id != null) body.theme_id = Number(theme_id);
//         if (group_id != null) body.group_id = Number(group_id);
//       } else {
//         // Default to live/practice path
//         url = `${SCHOOL_QUIZ_API_BASE_URL}/add-question`;
//         if (class_id != null) body.class_id = Number(class_id);
//         if (subject_id != null) body.subject_id = Number(subject_id);
//       }

//       // final sanity check: ensure required routing keys exist for chosen path
//       if (
//         url.endsWith("/add-theme-question") &&
//         (!body.theme_id || !body.group_id)
//       ) {
//         return rejectWithValue(
//           "theme_id and group_id are required for thematic questions."
//         );
//       }
//       if (
//         url.endsWith("/add-question") &&
//         (!body.class_id || !body.subject_id)
//       ) {
//         return rejectWithValue(
//           "class_id and subject_id are required for live/practice questions."
//         );
//       }

//       // send request
//       console.log("themen-id", theme_id);
//       const response = await axios.post(url, body);

//       if (response?.data) {
//         return response.data;
//       } else {
//         return rejectWithValue("Question could not be added.");
//       }
//     } catch (error) {
//       console.error("addManualQuestion error:", error);
//       // prefer backend message when available
//       const payloadErr =
//         error?.response?.data || error?.message || "Add question failed.";
//       return rejectWithValue(payloadErr);
//     }
//   }
// );

// updated code
export const addManualQuestion = createAsyncThunk(
  "schoolQuiz/addManualQuestion",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const {
        created_by,
        question,
        correct_option,
        option_A,
        option_B,
        option_C,
        option_D,
        level,
        // optional routing fields
        class_id,
        subject_id,
        theme_id,
        group_id,
        age_group_id,
        quiz_type, // optional explicit flag: "thematic" | "live" | "practice"
      } = payload;

      // ✅ Minimal validation
      if (!question) return rejectWithValue("Question text is required.");
      if (!correct_option)
        return rejectWithValue("Correct option is required.");
      if (!option_A || !option_B || !option_C || !option_D)
        return rejectWithValue("All options (A–D) are required.");
      if (!level) return rejectWithValue("Difficulty level is required.");
      if (!created_by)
        return rejectWithValue("created_by (user id) is required.");

      // ✅ Normalize correct_option to uppercase (in case backend is case-sensitive)
      const formattedCorrectOption = correct_option.toUpperCase();

      // ✅ Base body
      const body = {
        created_by,
        question,
        correct_option: formattedCorrectOption,
        option_A,
        option_B,
        option_C,
        option_D,
        level,
        quizType: quiz_type,
      };

      // ✅ Routing logic
      const SCHOOL_QUIZ_API_BASE_URL =
        "https://web1024.docmaster.in:5007/api/school/quiz/admin";
      let url = "";

      const isThematicExplicit = quiz_type === 3 || quiz_type === 4;
      // const hasThematicFields = theme_id != null || group_id != null;
      // const hasLiveFields = class_id != null || subject_id != null;

      if (
        isThematicExplicit
        // (!isThematicExplicit && hasThematicFields && !hasLiveFields)
      ) {
        // === Thematic Path ===
        url = `${SCHOOL_QUIZ_API_BASE_URL}/add-theme-question`;

        // Normalize theme_id → always an array (as backend expects [id])
        if (theme_id != null)
          body.theme_id = Array.isArray(theme_id)
            ? theme_id.map(Number)
            : [Number(theme_id)];

        if (group_id != null) body.group_id = Number(group_id);
        if (age_group_id != null) body.age_group_id = Number(age_group_id);
      } else {
        // === Live/Practice Path ===
        url = `${SCHOOL_QUIZ_API_BASE_URL}/add-question`;

        if (class_id != null) body.class_id = Number(class_id);
        if (subject_id != null) body.subject_id = Number(subject_id);
      }

      // ✅ Sanity checks
      if (url.endsWith("/add-theme-question")) {
        if (!body.theme_id || !body.group_id) {
          return rejectWithValue(
            "theme_id and group_id are required for thematic questions."
          );
        }
      }

      if (url.endsWith("/add-question")) {
        if (!body.class_id || !body.subject_id) {
          return rejectWithValue(
            "class_id and subject_id are required for live/practice questions."
          );
        }
      }

      // ✅ Log for debugging
      console.log("📦 Final Payload Sent:", body);
      console.log("🌐 Endpoint:", url);

      // ✅ Send request
      const response = await axios.post(url, body);

      if (response?.data) {
        return response.data;
      } else {
        return rejectWithValue("Question could not be added.");
      }
    } catch (error) {
      console.error("❌ addManualQuestion error:", error);
      const payloadErr =
        error?.response?.data || error?.message || "Add question failed.";
      return rejectWithValue(payloadErr);
    }
  }
);

// schoolQuizSlice or thunks file
export const getQuizQuestions = createAsyncThunk(
  "schoolQuiz/getQuizQuestions",
  async ({ body }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${SCHOOL_QUIZ_API_BASE_URL}/questions`,
        body
      );
      if (response.data) return response.data;
      return rejectWithValue("No questions found.");
    } catch (error) {
      console.error("getQuizQuestions Error:", error);
      return rejectWithValue(
        error.response?.data?.message || "Request failed."
      );
    }
  }
);
// export const fetchQuizTypes = createAsyncThunk(
//   "schoolQuiz/fetchQuizTypes",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await axios.get(`${quizTypesNew}`);
//       console.log(response);
//       if (response.data) return response.data;
//       return rejectWithValue("No quiz types found.");
//     } catch (error) {
//       console.error("getQuiztypes Error:", error);
//       return rejectWithValue(
//         error.response?.data?.message || "Request failed."
//       );
//     }
//   }
// );
export const fetchQuizTypes = createAsyncThunk(
  "themes/fetchQuizTypes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${quizTypesNew}`);
      return response.data || [];
    } catch (error) {
      console.error("fetchClasses error:", error);
      return rejectWithValue("Failed to fetch subjects");
    }
  }
);

export const getThematicQuizQuestions = createAsyncThunk(
  // <- different type prefix! important
  "schoolQuiz/getThematicQuizQuestions",
  async ({ body }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${SCHOOL_QUIZ_API_BASE_URL}/theme-questions`,
        body
      );
      if (response.data) return response.data;
      return rejectWithValue("No thematic questions found.");
    } catch (error) {
      console.error("getThematicQuizQuestions Error:", error);
      return rejectWithValue(
        error.response?.data?.message || "Request failed."
      );
    }
  }
);

// 25 july
const sanitizeBody = (obj) => {
  const cleaned = {};
  Object.entries(obj).forEach(([k, v]) => {
    // keep 0 but drop null/undefined/empty-string
    if (
      v !== undefined &&
      v !== null &&
      !(typeof v === "string" && v.trim() === "")
    ) {
      cleaned[k] = v;
    }
  });
  return cleaned;
};

// Regular update (class/subject)
export const updateQuestion = createAsyncThunk(
  "schoolQuiz/updateQuestion",
  async (payload /* whole payload object expected */, { rejectWithValue }) => {
    try {
      const { id, ...rest } = payload || {};
      if (!id) return rejectWithValue("Missing question id.");

      const body = sanitizeBody(rest);

      // optional: coerce numeric ids if required by API
      if (body.class_id) body.class_id = Number(body.class_id);
      if (body.subject_id) body.subject_id = Number(body.subject_id);

      // debug
      // console.log("updateQuestion body:", body);

      const response = await axios.put(
        `${SCHOOL_QUIZ_API_BASE_URL}/update-questions/${id}`,
        body
      );

      if (response?.data) return response.data;
      return rejectWithValue("Question can't be updated.");
    } catch (error) {
      console.error("Update Question Error:", error);
      return rejectWithValue(
        error?.response?.data?.message ?? error.message ?? "Update failed."
      );
    }
  }
);

// Thematic update (theme + group)
export const updateThematicQuestion = createAsyncThunk(
  "schoolQuiz/updateThematicQuestion",
  async (payload /* whole payload object expected */, { rejectWithValue }) => {
    console.log(payload);
    try {
      const { id, ...rest } = payload || {};
      if (!id) return rejectWithValue("Missing question id.");

      const body = sanitizeBody(rest);

      // Validate theme/group presence for thematic endpoint
      if (!body.theme_id || !body.group_id) {
        return rejectWithValue(
          "theme_id and group_id are required for thematic update."
        );
      }

      // optional: coerce numeric ids if required by API
      // body.theme_id = body.theme_id;
      body.group_id = Number(body.group_id);

      // console.log("updateThematicQuestion body:", body);

      const response = await axios.put(
        `${SCHOOL_QUIZ_API_BASE_URL}/update-theme-questions/${id}`,
        body
      );

      if (response?.data) return response.data;
      return rejectWithValue("Thematic question can't be updated.");
    } catch (error) {
      console.error("Update Thematic Question Error:", error);
      return rejectWithValue(
        error?.response?.data?.message ?? error.message ?? "Update failed."
      );
    }
  }
);
export const deleteQuestion = createAsyncThunk(
  "schoolQuiz/deleteQuestion",
  async ({ id, updated_by, quizType }, { rejectWithValue }) => {
    try {
      let url;
      if (quizType === "thematic") {
        url = `${SCHOOL_QUIZ_API_BASE_URL}/delete-theme-questions/${id}`;
      } else {
        url = `${SCHOOL_QUIZ_API_BASE_URL}/delete-questions/${id}`;
      }
      const response = await axios.delete(`${url}`, {
        data: { updated_by }, // ✅ pass body under `data`
      });
      if (response.data) {
        return response.data;
      } else {
        return rejectWithValue("Question can't be deleted.");
      }
    } catch (error) {
      console.error("Delete Question Error:", error);
      return rejectWithValue(
        error.response?.data?.message || "Deletion failed."
      );
    }
  }
);

// const API_new = "http://192.168.0.21:5007/api/quiz/admin/";
const laws_endpt = `${API_BASE_URL}/quiz/admin/laws`;
// get laws

export const deleteCategory = createAsyncThunk(
  "schoolQuiz/deleteCategory",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${laws_endpt}/${id}`);
      if (response.data) {
        alert("deleted category successfully");
        return response.data;
      } else {
        return rejectWithValue("Unable to create law.");
      }
    } catch (error) {
      console.error(error);
      return rejectWithValue(
        error.response?.data?.message || "deletion of law failed."
      );
    }
  }
);

export const addOrUpdateSubject = createAsyncThunk(
  "schoolQuiz/addOrUpdateSubject",
  async ({ subject_id, subject_name, mode }, { rejectWithValue }) => {
    try {
      let apiUrl = "";
      let method = "";

      if (mode === "Add") {
        apiUrl = `${SCHOOL_QUIZ_API_BASE_URL}/add-subject`;
        method = "post";
      } else if (mode === "Update") {
        apiUrl = `${SCHOOL_QUIZ_API_BASE_URL}/update-subject/${subject_id}`;
        method = "put";
      } else {
        return rejectWithValue("Invalid mode specified");
      }

      // 👇 send subject_name in the body
      const response = await axios[method](apiUrl, { subject_name });
      console.log(response.data.message);
      if (response.data) {
        alert(response.data.message);
        return response.data;
      } else {
        return rejectWithValue("Unexpected server response.");
      }
    } catch (error) {
      console.error("❌ addOrUpdateSubject error:", error);
      return rejectWithValue(
        error.response?.data?.message || "Failed to add/update subject."
      );
    }
  }
);
export const addOrUpdateClasses = createAsyncThunk(
  "schoolQuiz/addOrUpdateClasses",
  async ({ class_id, class_name, mode, subject_ids }, { rejectWithValue }) => {
    try {
      let apiUrl = "";
      let method = "";
      if (mode === "Add") {
        apiUrl = `${SCHOOL_QUIZ_API_BASE_URL}/add-class`;
        method = "post";
      } else if (mode === "Update") {
        apiUrl = `${SCHOOL_QUIZ_API_BASE_URL}/update-class/${class_id}`;
        method = "put";
      } else {
        return rejectWithValue("Invalid mode specified");
      }

      // 👇 send subject_name in the body
      const response = await axios[method](apiUrl, { class_name, subject_ids });
      console.log(response.data.message);
      if (response.data) {
        alert(response.data.message);
        return response.data;
      } else {
        return rejectWithValue("Unexpected server response.");
      }
    } catch (error) {
      console.error("❌ addOrUpdateClass error:", error);
      return rejectWithValue(
        error.response?.data?.message || "Failed to add/update subject."
      );
    }
  }
);
export const deleteSubject = createAsyncThunk(
  "schoolQuiz/deleteSubject",
  async ({ subject_id }, { rejectWithValue }) => {
    console.log(subject_id);
    try {
      const response = await axios.delete(
        `${SCHOOL_QUIZ_API_BASE_URL}/delete-subject/${subject_id}`
      );
      if (response.data) {
        alert(response?.data?.message || "deleted subject successfully");
        return response.data;
      } else {
        return rejectWithValue("Unable to delete subject");
      }
    } catch (error) {
      console.error(error);
      return rejectWithValue(
        error.response?.data?.message || "deletion of law failed."
      );
    }
  }
);
export const deleteClass = createAsyncThunk(
  "schoolQuiz/deleteClass",
  async ({ class_id }, { rejectWithValue }) => {
    console.log(class_id);
    try {
      const response = await axios.delete(
        `${SCHOOL_QUIZ_API_BASE_URL}/delete-class/${class_id}`
      );
      if (response.data) {
        alert(response?.data?.message || "deleted class successfully");
        return response.data;
      } else {
        return rejectWithValue("Unable to delete class");
      }
    } catch (error) {
      console.error(error);
      return rejectWithValue(
        error.response?.data?.message || "deletion of law failed."
      );
    }
  }
);
export const fetchSubjectBasedClassesData = createAsyncThunk(
  "schoolQuiz/fetchSubjectBasedClassesData",
  async ({ subject_id }, { rejectWithValue }) => {
    if (subject_id) {
      try {
        const response = await axios.get(
          `${SCHOOL_QUIZ_API_BASE_URL}/classes-by-subject/${subject_id}`
        );
        if (response.data) {
          console.log(response.data);
          return response.data;
        } else {
          return rejectWithValue("Unable to delete class");
        }
      } catch (error) {
        console.error(error);
        return rejectWithValue(
          error.response?.data?.message || "deletion of law failed."
        );
      }
    } else {
      return;
    }
  }
);

const createAsyncCases = (builder, asyncThunk, key, stateKey = null) => {
  builder
    .addCase(asyncThunk.pending, (state) => {
      state[`${key}Status`] = "loading";
      state[`${key}Error`] = null; // reset error on new request
    })
    .addCase(asyncThunk.fulfilled, (state, action) => {
      state[`${key}Status`] = "succeeded";
      if (stateKey) state[stateKey] = action.payload;
    })
    .addCase(asyncThunk.rejected, (state, action) => {
      state[`${key}Status`] = "failed";
      state[`${key}Error`] = action.error?.message || "Something went wrong";
    });
};

const schoolQuizSlice = createSlice({
  name: "schoolQuiz",
  initialState: {
    difficultyLevels: [],
    questionsList: [],
    errorLogs: [],
    view_logs: false,
    searchTerm: "",
    loading: false,
    openPopUp: false,
    mode: "",
    theme_id: "",
    group_id: "",
    sub_theme_id: "",
    themes: [],
    themesStatus: "idle",
    themesError: null,
    groups: [],
    groupsStatus: "idle",
    groupsError: null,
    newQuestionForm: {
      question: "",
      option_a: "",
      option_b: "",
      option_c: "",
      option_d: "",
      correct_option: "",
      difficulty_level: "",
    },
    questionForm: {
      subjectSpecificClasses: [],
      questionId: "",
      question: "",
      option_a: "",
      option_b: "",
      option_c: "",
      option_d: "",
      correct_option: "",
      difficulty_level: "",
      created_by: "",
      updated_at: "",
      created_by_user_id: "",
      updated_at_user_id: "",
      created_at: "",
      theme_id: "",
      group_id: "",
      themeData: [],
      class_ids: [],
    },
    offset: "",
    subThemes: [],
    selectedSubThemes: [],
    quizzes: [],
    ageGrps: [],
    //for the laws
    categories: [],
    selectedCategory: "",
    updatedCategory: "",
    newCategory: "",
    newCategoryDescriptn: "",
    option: "",

    //for the upload excel file
    uploadStatus: "idle",
    uploadError: null,
    //
    subjectsList: [],
    classesList: [],
    classesData: {
      class_id: "",
      class_name: "",
      subjects: [],
      open: false,
      mode: "",
    },
    subjectsData: {
      subject_id: "",
      subject_name: "",
      open: false,
      mode: "",
    },
    quizType: null,
    subQuizType: "",
    quizTypesList: [],
    // for question upload n manual insertion
    subjectBasedClasses: [],
    class_id: "",
    subject_id: "",
  },
  reducers: {
    setState: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
    setNewQuestionForm: (state, action) => {
      const { key, value } = action.payload;
      state.newQuestionForm[key] = value;
    },
    setSubjectForm: (state, action) => {
      const { key, value } = action.payload;
      state.subjectsData[key] = value;
    },
    setClassForm: (state, action) => {
      const { key, value } = action.payload;
      state.classesData[key] = value;
    },

    setQuestionForm: (state, action) => {
      if (action.payload.key) {
        // handle single field update
        state.questionForm[action.payload.key] = action.payload.value;
      } else {
        // handle full object (like on initial edit/view load)
        state.questionForm = {
          ...state.questionForm,
          ...action.payload,
        };
      }
    },
    resetQuestionForm: (state) => {
      state.questionForm = {
        question: "",
        option_a: "",
        option_b: "",
        option_c: "",
        option_d: "",
        correct_option: "",
        difficulty_level: "",
      };
    },
    resetNewQuestionForm: (state) => {
      state.newQuestionForm = {
        question: "",
        option_a: "",
        option_b: "",
        option_c: "",
        option_d: "",
        correct_option: "",
        difficulty_level: "",
      };
    },
  },
  extraReducers: (builder) => {
    createAsyncCases(builder, fetchGroups, "groups", "groups");
    createAsyncCases(builder, fetchThemes, "themes", "themes");
    createAsyncCases(builder, fetchSubjects, "subjectsList", "subjectsList");
    createAsyncCases(builder, fetchClasses, "classesList", "classesList");
    createAsyncCases(
      builder,
      fetchSubjectBasedClassesData,
      "subjectBasedClasses",
      "subjectBasedClasses"
    );
    createAsyncCases(builder, fetchQuizTypes, "quizTypesList", "quizTypesList");
    // for uploadQuizExcel
    builder
      .addCase(uploadQuizExcel.pending, (state) => {
        state.uploadStatus = "loading";
        state.uploadError = null;
      })
      .addCase(uploadQuizExcel.fulfilled, (state, action) => {
        state.uploadStatus = "succeeded";
        state.questions = action.payload;
      })
      .addCase(uploadQuizExcel.rejected, (state, action) => {
        state.uploadStatus = "failed";
        state.uploadError = action.payload;
      });
    // for addManualQuestion
    builder
      .addCase(addManualQuestion.pending, (state) => {
        state.uploadStatus = "loading";
        state.uploadError = null;
      })
      .addCase(addManualQuestion.fulfilled, (state, action) => {
        state.uploadStatus = "succeeded";
        state.questions = action.payload;
      })
      .addCase(addManualQuestion.rejected, (state, action) => {
        state.uploadStatus = "failed";
        state.uploadError = action.payload;
      });
    // inside extraReducers builder in schoolQuizSlice
    builder
      .addCase(getQuizQuestions.fulfilled, (state, action) => {
        state.questionsList = action.payload || {
          questions: [],
          offset: 0,
          limit: 100,
        };
      })
      .addCase(getQuizQuestions.rejected, (state) => {
        state.questionsList = { questions: [], offset: 0, limit: 100 };
      });

    // add these for thematic thunk as well
    builder
      .addCase(getThematicQuizQuestions.fulfilled, (state, action) => {
        state.questionsList = action.payload || {
          questions: [],
          offset: 0,
          limit: 100,
        };
      })
      .addCase(getThematicQuizQuestions.rejected, (state) => {
        state.questionsList = { questions: [], offset: 0, limit: 100 };
      });

    builder
      .addCase(viewErrorLogs.fulfilled, (state, action) => {
        state.errorLogs = action.payload || {
          errors: [],
          offset: 0,
          limit: 100,
        };
      })
      .addCase(viewErrorLogs.rejected, (state) => {
        state.errorLogs = { errors: [], offset: 0, limit: 100 };
      });

    builder
      .addCase(getAgeGroups.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAgeGroups.fulfilled, (state, action) => {
        state.loading = false;
        state.ageGrps = action.payload || []; // ✅ FIXED
      })
      .addCase(getAgeGroups.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch users";
      });
  },
});
export const {
  setState,
  resetNewQuestionForm,
  setNewQuestionForm,
  setQuestionForm,
  resetQuestionForm,
  setSubjectForm,
  setClassForm,
} = schoolQuizSlice.actions;

export default schoolQuizSlice.reducer;
